<template>
  <div class="regionList">
	<v-content>
      <center v-if="loaded == false"><img class="imgLoader" src="../shared/assets/images/3dloader.gif" /></center>
      <v-flex xs3>
        <div class="relative" v-if="loaded == true">
          <a v-if="search != ''" @click.prevent="fncClearSearch" class="searchTypeClear"><i class="material-icons searchTypeClearText">close</i></a>
          <v-text-field append-icon="search" v-if="search == ''" @input="fncCustomSearch" label="Search" solo single-line v-model="search"></v-text-field>
          <v-text-field v-if="search != ''" @input="fncCustomSearch" label="Search" solo single-line v-model="search"></v-text-field><br />
        </div>
      </v-flex>
		<v-data-table v-if="loaded == true" :headers="headers" :items="filteredSearch" :pagination.sync="pagination" expand class="elevation-1 mainTable" :rows-per-page-items="[1000]">
			<template slot="items" slot-scope="props">
				<tr v-if="props.item.display == true">
					<td v-if="props.expanded == true" width="80%" @click="props.expanded = !props.expanded" ><i v-if="props.item.children && props.item.children.length > 0" class="material-icons showHide">arrow_forward</i>{{ props.item.name }}</td>
                    <td v-else width="80%" @click="props.expanded = !props.expanded" ><i v-if="props.item.children && props.item.children.length > 0" class="material-icons showHide">arrow_downward</i>{{ props.item.name }}</td>
					<td width="20%" v-if="objAuthorize.privileges.indexOf('VIEW_REGIONS') !== -1" ><a @click.prevent="fncEditRegion(props.item)"><i class="material-icons">edit</i></a></td>
				</tr>
			</template>
            <template slot="expand" slot-scope="props">
              <v-data-table :search="search" :headers="headers" :items="props.item.children" expand class="elevation-1 subTable subTable1 minTable" hide-actions :rows-per-page-items="[10000000]">
                <template slot="items" slot-scope="props">
                  <tr>
                    <td v-if="props.expanded == true" width="80%" @click="props.expanded = !props.expanded" class="levelone"><i v-if="props.item.children && props.item.children.length > 0" class="material-icons showHide">arrow_forward</i>{{ props.item.name }}</td>
                    <td v-else width="80%" @click="props.expanded = !props.expanded" class="levelone"><i v-if="props.item.children && props.item.children.length > 0" class="material-icons showHide">arrow_downward</i>{{ props.item.name }}</td>
                    <td width="20%" v-if="objAuthorize.privileges.indexOf('VIEW_REGIONS') !== -1" ><a @click.prevent="fncEditRegion(props.item)"><i class="material-icons">edit</i></a></td>
                  </tr>
                </template>
                <template slot="expand" slot-scope="props">
                  <v-data-table :search="search" :headers="headers" :items="props.item.children" expand class="elevation-1 subTable2 minTable" hide-actions :rows-per-page-items="[10000000]">
                    <template slot="items" slot-scope="props">
                      <tr>
                        <td v-if="props.expanded == true" width="80%" @click="props.expanded = !props.expanded" class="leveltwo"><i v-if="props.item.children && props.item.children.length > 0" class="material-icons showHide">arrow_forward</i>{{ props.item.name }}</td>
                        <td v-else width="80%" @click="props.expanded = !props.expanded" class="leveltwo"><i v-if="props.item.children && props.item.children.length > 0" class="material-icons showHide">arrow_downward</i>{{ props.item.name }}</td>
                        <td width="20%" v-if="objAuthorize.privileges.indexOf('VIEW_REGIONS') !== -1" ><a @click.prevent="fncEditRegion(props.item)"><i class="material-icons">edit</i></a></td>
                      </tr>
                    </template>
                  </v-data-table>
                </template>
                <template slot="expand" slot-scope="props">
                  <v-data-table :search="search" :headers="headers" :items="props.item.children" expand class="elevation-1 subTable2 minTable" hide-actions :rows-per-page-items="[10000000]">
                    <template slot="items" slot-scope="props">
                      <tr>
                        <td v-if="props.expanded == true" width="80%" @click="props.expanded = !props.expanded" class="levelthree"><i v-if="props.item.children && props.item.children.length > 0" class="material-icons showHide">arrow_forward</i>{{ props.item.name }}</td>
                        <td v-else width="80%" @click="props.expanded = !props.expanded" class="levelthree"><i v-if="props.item.children && props.item.children.length > 0" class="material-icons showHide">arrow_downward</i>{{ props.item.name }}</td>
                        <td width="20%" v-if="objAuthorize.privileges.indexOf('VIEW_REGIONS') !== -1" ><a @click.prevent="fncEditRegion(props.item)"><i class="material-icons">edit</i></a></td>
                      </tr>
                    </template>
                    <template slot="expand" slot-scope="props">
                      <v-data-table :search="search" :headers="headers" :items="props.item.children" expand class="elevation-1 subTable3 minTable" hide-actions :rows-per-page-items="[10000000]">
                        <template slot="items" slot-scope="props">
                          <tr>
                            <td v-if="props.expanded == true" width="80%" @click="props.expanded = !props.expanded" class="levelfour"><i v-if="props.item.children && props.item.children.length > 0" class="material-icons showHide">arrow_forward</i>{{ props.item.name }}</td>
                            <td v-else width="80%" @click="props.expanded = !props.expanded" class="levelfour"><i v-if="props.item.children && props.item.children.length > 0" class="material-icons showHide">arrow_downward</i>{{ props.item.name }}</td>
                            <td width="20%" v-if="objAuthorize.privileges.indexOf('VIEW_REGIONS') !== -1" ><a @click.prevent="fncEditRegion(props.item)"><i class="material-icons">edit</i></a></td>
                          </tr>
                        </template>
                      </v-data-table>
                    </template>
                  </v-data-table>
                </template>
              </v-data-table>
            </template>
		</v-data-table>
	</v-content>
</div>
</template>

<script>

  import { mapGetters } from 'vuex';
  import Modal from '@/components/shared/modal';

  export default {
	name: 'PrivList',
    data () {
		return {
          search: '',
          pagination: { 'sortBy': 'id', 'ascending': true },
          filteredSearch: [],
			headers: [
				{ text: 'Name', value: 'name', width: '80%' },
				/*{ text: 'Type', value: 'type' },*/
				/*{ text: 'Children', value: 'children' },				*/
                { text: 'Edit', value: 'edit', width: '20%' }
          ],
            loaded: false
		}
	},
    methods: {
      fncClearSearch() {
        this.search = '';
        this.fncCustomSearch();
      },
      fncCustomSearch() {
        if ( this.search == '' ) {
          this.$store.dispatch('fncPopulateUserRegions');
        } else {
          this.$store.commit({
            type: 'fncFilterRegions',
            search: this.search,
            regions: this.userRegions
          })
        }

        },
		fncViewChildren(regionName, regionId){
			this.$store.dispatch('fncGetRegionChildren', regionId);
			var modalDetails = { title: regionName + ' Locations', component: 'modal-region-children', mstate: true, params: {} };
			this.$store.commit({
				type: 'setModal',
				details: modalDetails
			});
		},
        fncEditRegion(region) {
			this.$store.dispatch({
				type: 'setObjRegionEdit',
				regionObj: region
			});
			/*this.$store.dispatch({
				type: 'setObjRegionParents',
				regionType: region.type
			});
			var modalDetails = { title: 'Edit Region', component: 'modal-region-edit', mstate: true, params: {} };
			this.$store.commit({
				type: 'setModal',
				details: modalDetails
			});*/
		},
		fncDeleteRegion(region) {
			var regionId = region.id;
			var confirmDelete = confirm('Are you sure you want to delete this region');
			if(confirmDelete === true) {
				this.$store.dispatch({
					type: 'fncDeleteRegion',
					id: regionId
				});
			}
		}
	},
	computed: {
      ...mapGetters([
            'globalModalState',
			'objAuthorize',
            'regionList',
            'userRegions',
            'regionSearch'
		])
	},
	beforeMount() {
      // this.$store.dispatch('fncPopulateRegionList');
      this.$store.dispatch('fncPopulateUserRegions');
    },
    mounted() {
      window.regions = this.userRegions;
    },
    watch: {
      userRegions() {
        this.filteredSearch = this.userRegions;
      },
      regionSearch() {
        if (this.search != '') {
          this.filteredSearch = this.regionSearch;
        } else {
          this.filteredSearch = this.userRegions;
        }
      },
      filteredSearch() {
        console.log( this.filteredSearch );
        if (this.filteredSearch == '' ) {
          this.loaded = false;
        } else {
          this.loaded = true;
        }
      }
    }
}
</script>

<style>
	.node circle {
		fill: #fff;
		stroke: steelblue;
		stroke-width: 3px;
	}

	.node text { font: 12px sans-serif; }

	.node--internal text {
		text-shadow: 0 1px 0 #fff, 0 -1px 0 #fff, 1px 0 0 #fff, -1px 0 0 #fff;
	}

	.link {
		fill: none;
		stroke: #ccc;
		stroke-width: 2px;
	}
</style>
